import React, { createContext, useCallback, useContext } from "react";

export type EditingBlocksContextType = {
  editingBlocks: Record<string, boolean>;
  setEditingBlocks: (key: string, bool: boolean) => void;
};

export const EditingBlocksContext = createContext<EditingBlocksContextType>({
  editingBlocks: {},
  setEditingBlocks: () => {},
});

interface EditingBlocksProviderProps {
  editingBlocks: Record<string, boolean>;
  setEditingBlocks: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

export const EditingBlocksProvider = ({ editingBlocks, setEditingBlocks, children }: React.PropsWithChildren<EditingBlocksProviderProps>) => {
  const _setEditingBlocks = useCallback(
    (key: string, bool: boolean) => {
      setEditingBlocks((prev) => {
        return { ...prev, [key]: bool };
      });
    },
    [setEditingBlocks],
  );

  return <EditingBlocksContext.Provider value={{ editingBlocks, setEditingBlocks: _setEditingBlocks }}>{children}</EditingBlocksContext.Provider>;
};

export const useEditingBlocksContext = (): EditingBlocksContextType => {
  const { editingBlocks, setEditingBlocks } = useContext(EditingBlocksContext);
  return { editingBlocks, setEditingBlocks };
};
